module.exports = __webpack_public_path__ + "img/Weapon_32.d49f1472.png";